<div class="dialog-backdrop" *ngIf="isVisible" (click)="handleBackdropClick($event)" (keydown.escape)="close()" tabindex="-1">
  <div class="merchant-id-dialog">
    <!-- Icon Section -->
    <div class="icon-section">
      <img src="assets/img/Info.svg" alt="Info Icon" class="info-icon" />
    </div>

    <!-- Text Section -->
    <div class="text-section">
      <h2>{{ dialogTitle }}</h2>
      
      <!-- Form Section -->
      <form (ngSubmit)="handleSubmit()" class="form-container">
        <div class="form-group">
          <input
            type="text"
            id="merchantId"
            name="merchantId"
            class="form-input"
            [(ngModel)]="formData.merchantId"
            (ngModelChange)="validateMerchantId()"
            placeholder="Enter Merchant ID"
            required
            [attr.aria-required]="true"
          />
          <div *ngIf="merchantIdError" class="error-message">{{merchantIdError}}</div>
        </div>
      </form>
    </div>

    <!-- Actions Section -->
    <div class="actions-section">
      <button 
        type="button"
        class="primary-button"
        [disabled]="!isFormValid()"
        (click)="handleSubmit()">
        Approve User
      </button>
      <a 
        class="secondary-link"
        (click)="handleCancel()">
        Cancel
      </a>
    </div>
  </div>
</div>
